<template>
  <v-dialog v-model="visible" @keydown.esc="close" persistent scrollable max-width="500">
    <v-form ref="fieldForm" @submit.prevent="submit">
      <v-card class="glass-card-eracun">
        <div class="glass-header-eracun">
          <div class="header-pattern"></div>
          <v-card-title class="headline-eracun white--text">
            {{ editing ? 'Uredi polje' : 'Novo polje' }}
          </v-card-title>
        </div>
        <v-card-text class="pt-6 pb-4">
          <v-text-field
            v-model="label"
            label="Labela"
            outlined
            dense
            class="filter-select"
            :rules="[rules.req]"
          ></v-text-field>
          <v-select
            v-model="type"
            :items="typeOptions"
            item-text="text"
            item-value="value"
            label="Tip polja"
            outlined
            dense
            class="filter-select"
            :rules="[rules.req]"
          ></v-select>
          <v-select
            v-if="type === 'attribute'"
            v-model="attributeField"
            :items="attributeOptions"
            item-text="label"
            item-value="value"
            label="Atribut artikla"
            outlined
            dense
            class="filter-select"
            :rules="[rules.req]"
          ></v-select>
          <v-text-field
            v-if="type === 'manual'"
            v-model="defaultValue"
            label="Default vrijednost (opcionalno)"
            hint="Prikazuje se svim artiklima kojima ovo polje nije posebno popunjeno."
            persistent-hint
            outlined
            dense
            class="filter-select"
          ></v-text-field>
          <v-radio-group v-model="column" row label="Kolona" class="mt-4">
            <v-radio label="Kolona 1" :value="1" color="#3989C9"></v-radio>
            <v-radio label="Kolona 2" :value="2" color="#3989C9"></v-radio>
          </v-radio-group>
          <v-checkbox v-model="printaj" label="Printaj" color="#00838F" hide-details></v-checkbox>
        </v-card-text>
        <v-card-actions class="pb-4 px-4">
          <v-spacer></v-spacer>
          <v-btn text class="cancel-btn-eracun" @click="close">Odustani</v-btn>
          <v-btn class="primary-btn-eracun" type="submit">
            <v-icon small class="mr-1">mdi-content-save-outline</v-icon>
            Spremi polje
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import rules from '@/plugins/rules'
import { ITEM_ATTRIBUTE_OPTIONS } from './declarationsService.js'

export default {
  name: 'AddDeclarationField',
  data: () => ({
    visible: false,
    editing: false,
    label: '',
    type: 'manual',
    attributeField: null,
    defaultValue: '',
    column: 1,
    printaj: true,
    attributeOptions: ITEM_ATTRIBUTE_OPTIONS,
    typeOptions: [
      { text: 'Ručni unos', value: 'manual' },
      { text: 'Atribut artikla', value: 'attribute' }
    ],
    rules: {
      req: rules.req()
    }
  }),
  methods: {
    open (existingField) {
      if (existingField) {
        this.editing = true
        this.label = existingField.label
        this.type = existingField.type
        this.attributeField = existingField.attribute_field || null
        this.defaultValue = existingField.default_value || ''
        this.column = existingField.column
        this.printaj = existingField.printaj
      } else {
        this.editing = false
        this.label = ''
        this.type = 'manual'
        this.attributeField = null
        this.defaultValue = ''
        this.column = 1
        this.printaj = true
      }
      this.visible = true
    },
    close () {
      this.visible = false
    },
    submit () {
      if (!this.$refs.fieldForm.validate()) return
      this.$emit('save', {
        label: this.label,
        type: this.type,
        attribute_field: this.type === 'attribute' ? this.attributeField : null,
        default_value: this.type === 'manual' ? this.defaultValue : null,
        column: this.column,
        printaj: this.printaj
      })
      this.visible = false
    }
  }
}
</script>
<style scoped>
.glass-card-eracun {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  overflow: hidden !important;
}
.glass-header-eracun {
  background: linear-gradient(135deg, rgba(0, 179, 190, 0.5) 0%, rgba(57, 137, 201, 0.45) 50%, rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 24px 24px 20px !important;
  position: relative !important;
}
.header-pattern {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  z-index: 0;
}
.headline-eracun {
  font-size: 20px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  position: relative !important;
  z-index: 1 !important;
  padding: 0 !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.glass-card-eracun .v-card__text {
  background: rgba(255, 255, 255, 0.5) !important;
}
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: #B0BEC5 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}
.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: #90A4AE !important;
}
.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00838F !important;
  border-width: 2px !important;
}
.primary-btn-eracun {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #3989c9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
}
.primary-btn-eracun:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
}
.primary-btn-eracun .v-icon {
  color: #3989c9 !important;
}
.cancel-btn-eracun {
  color: rgba(70, 70, 80, 0.7) !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
}
.cancel-btn-eracun:hover {
  color: rgba(70, 70, 80, 1) !important;
  background: rgba(0, 0, 0, 0.04) !important;
}
</style>
